import { ComboBoxProps } from "./ComboBox";

const defaultKeyColumnName = "code";
const defaultValueColumnName = "name";

export const getColumnNames = (
    props: ComboBoxProps
): { keyColumnName: string; valueColumnName: string; searchColumnNames: string[] } => ({
    keyColumnName: props.keyColumnName ?? defaultKeyColumnName,
    valueColumnName: props.valueColumnName ?? defaultValueColumnName,
    searchColumnNames: props.searchColumnNames ?? [],
});
